import { render } from "./ScoreboardEntryModal.vue?vue&type=template&id=9f6c8e5c&scoped=true&ts=true"
import script from "./ScoreboardEntryModal.vue?vue&type=script&lang=ts"
export * from "./ScoreboardEntryModal.vue?vue&type=script&lang=ts"

import "./ScoreboardEntryModal.vue?vue&type=style&index=0&id=9f6c8e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6c8e5c"]])

export default __exports__